import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Registered Trades Scraping List")
], -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_6 = { class: "indicator-label" }
const _hoisted_7 = { class: "indicator-progress" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_9 = { class: "svg-icon svg-icon-2" }
const _hoisted_10 = { class: "card-body pt-0" }
const _hoisted_11 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_12 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "svg-icon svg-icon-3" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'registered-trades'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.fileInput.click())),
                type: "submit",
                id: "kt_account_profile_details_submit",
                ref: "submitButton",
                class: "btn btn-light-primary me-3"
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.translate('importRegisteredTrades')), 1),
                _createElementVNode("span", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_8
                ])
              ], 512),
              _createElementVNode("input", {
                type: "file",
                class: "d-none",
                ref: "fileInput",
                accept: ".xlsx, .xls, .csv",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadRegisteredTrades && _ctx.uploadRegisteredTrades(...args))),
                name: "fileInput",
                autocomplete: "off",
                id: "upload-files"
              }, null, 544),
              (_ctx.can('create', 'registered-trades'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo('registered-trades-scraping-creating')))
                  }, [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate('pullRegisteredTrades')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-id": _withCtx(({ row: registeredTradeScraping }) => [
              _createTextVNode(_toDisplayString(registeredTradeScraping.id), 1)
            ]),
            "cell-governorate": _withCtx(({ row: registeredTradeScraping }) => [
              _createTextVNode(_toDisplayString(registeredTradeScraping.governorate), 1)
            ]),
            "cell-area": _withCtx(({ row: registeredTradeScraping }) => [
              _createTextVNode(_toDisplayString(registeredTradeScraping.area), 1)
            ]),
            "cell-propertyCategory": _withCtx(({ row: registeredTradeScraping }) => [
              _createTextVNode(_toDisplayString(registeredTradeScraping.propertyCategory), 1)
            ]),
            "cell-propertyType": _withCtx(({ row: registeredTradeScraping }) => [
              _createTextVNode(_toDisplayString(registeredTradeScraping.propertyType), 1)
            ]),
            "cell-action": _withCtx(({ row: registeredTradeScraping }) => [
              _createTextVNode(_toDisplayString(registeredTradeScraping.action), 1)
            ]),
            "cell-percentage": _withCtx(({ row: registeredTradeScraping }) => [
              _createTextVNode(_toDisplayString(registeredTradeScraping.percentage), 1)
            ]),
            "cell-block": _withCtx(({ row: registeredTradeScraping }) => [
              _createTextVNode(_toDisplayString(registeredTradeScraping.block), 1)
            ]),
            "cell-transactionDate": _withCtx(({ row: registeredTradeScraping }) => [
              _createTextVNode(_toDisplayString(registeredTradeScraping.transactionDate), 1)
            ]),
            "cell-size": _withCtx(({ row: registeredTradeScraping }) => [
              _createTextVNode(_toDisplayString(registeredTradeScraping.size), 1)
            ]),
            "cell-salePrice": _withCtx(({ row: registeredTradeScraping }) => [
              _createTextVNode(_toDisplayString(registeredTradeScraping.salePrice
              ? new Intl.NumberFormat('en-US').format(
                  registeredTradeScraping.salePrice
                )
              : ''), 1)
            ]),
            "cell-duplicates": _withCtx(({ row: registeredTradeScraping }) => [
              (registeredTradeScraping.duplicates == 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(registeredTradeScraping.duplicates), 1))
            ]),
            "cell-actions": _withCtx(({ row: registeredTradeScraping }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (
              _ctx.editRegisteredScrapingTrades(registeredTradeScraping.id)
            ), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_14, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                ])
              ], 8, _hoisted_13),
              (_ctx.can('remove', 'registered-trades'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                    onClick: _withModifiers(($event: any) => (
              _ctx.toggleStatusRegisteredTrades(registeredTradeScraping)
            ), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_16, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                    ])
                  ], 8, _hoisted_15))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}